import { http } from "./config";
import authHeader from "./auth-header";

export default {
  verificar_status: () => {
    return http.get("/conexao-ivertex/status", {
      headers: authHeader(),
    });
  },
};
